import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-button-status-num',
  templateUrl: './button-status-num.component.html',
  styleUrls: ['./button-status-num.component.css']
})
export class ButtonStatusNumComponent implements OnInit {

  @Input() name:string
  @Input() amount:string
  @Input() custumer:string
  constructor() { }

  ngOnInit(): void {
  }

}
